import moment from 'moment';
import 'moment-timezone';
import $ from '../../../../../../docroot/core/assets/vendor/jquery/jquery.js';
import once from '../../../../../../docroot/core/assets/vendor/once/once';
import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/dist/ScrollToPlugin';
import { MotionPathPlugin } from 'gsap/dist/MotionPathPlugin';

global.DrupalBehavior = class {
  static register(theme, behavior, implementation) {}
};

global.Drupal = {
  attachBehaviors: jest.fn(),
  attachLibrary: jest.fn(),
  behaviors: {},
  behaviorsAttached: false,
  attach: jest.fn(),
  detach: jest.fn(),
  detachBehaviors: jest.fn(),
  t: jest.fn().mockImplementation((string) => string),
};

global.freshpaint = {
  addPageviewProperties: jest.fn(),
  track: jest.fn(),
};

global.$ = $;

global.jQuery = $;

export const matchMediaMockObject = {
  matches: true,
  addEventListener: jest.fn(),
  removeListener: jest.fn(),
  onchange: jest.fn(),
  dispatchEvent: jest.fn(),
};

global.matchMedia = jest.fn().mockImplementation((query) => ({
  ...matchMediaMockObject,
  media: query,
}));

global.moment = moment;

global.once = once;

global.gsap = gsap;

global.ScrollToPlugin = ScrollToPlugin;

global.MotionPathPlugin = MotionPathPlugin;

const mockGlide = {
  mount: jest.fn(),
  on: jest.fn(),
  index: 0,
  update: jest.fn(),
};

global.Glide = jest.fn().mockImplementation(() => mockGlide);

export const mockVideoModalInstance = {
  init: jest.fn(),
};
jest.mock('../components/video_modal', () => ({
  VideoModal: jest.fn().mockImplementation(() => mockVideoModalInstance),
}));
